// extracted by mini-css-extract-plugin
export default {"label":"Switch_label__jASMQ","text":"Switch_text__4HodX","track":"Switch_track__4K3tl","input":"Switch_input__kUoTu","slider":"Switch_slider__s60Ak"};